import React from 'react'

import { Button } from '@mui/material'

const ReanalyzeButton: React.SFC<ReanalyzeButtonProps> = ({ className, onClick }) => {
  return (
    <Button className={className} size="small" color="secondary" variant="outlined" onClick={onClick}>
      Reanalyze
    </Button>
  )
}

export type ReanalyzeButtonProps = {
  onClick?: () => any
  className: string
}

export default ReanalyzeButton
